const AnswerScroll = () => {
    const answers = localStorage.getItem('answers')? localStorage.getItem('answers').split(','):[];
    return (
        answers.map((index,value)=>{
            return (<div className="answer-piece" id={`q-${index + 1}`}>{index + 1}. {value}</div>);
        })
    )
  }
  


  
  export default AnswerScroll;